// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel-arrow[data-v-643a76fb]{position:absolute;top:50%;transform:translateY(-50%);z-index:1}.carousel-arrow--prev[data-v-643a76fb]{left:10px}.carousel-arrow--next[data-v-643a76fb]{right:10px}.damage-description[data-v-643a76fb]{margin-left:auto;margin-right:auto;max-width:-moz-max-content;max-width:max-content}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
